// ============================================================================
// GRAPHQL META / TRANSFORM HELPERS
// ============================================================================

export const withTimeEntryNodeId = <T extends { id: string }>(
  timeEntry: T
): T & { nodeId: string } => ({
  ...timeEntry,
  nodeId: timeEntry.id,
});

export const nowIso = (): string => new Date().toISOString();

const GRAPHQL_RELATION_FIELDS = ["tickets", "companies", "app_users", "contacts", "users"];

/**
 * Strip GraphQL metadata + nested relation objects from a mutation input so
 * Supabase GraphQL doesn't reject the payload.
 */
export function stripGraphqlMeta<T extends object>(input: T): T {
  const { __typename: _typename, ...rest } = input as T & { __typename?: unknown };
  const cleanInput = rest as Record<string, unknown>;

  GRAPHQL_RELATION_FIELDS.forEach((field) => {
    delete cleanInput[field];
  });

  Object.keys(cleanInput).forEach((key) => {
    const value = cleanInput[key];
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      "__typename" in (value)
    ) {
      delete cleanInput[key];
    }
  });

  return cleanInput as unknown as T;
}
